import preview from './preview'

const generate = {
    preview,
}

export default generate